import React, { Component } from 'react';
import SuccessComponent from "../core/SuccesComponent";
import { withRouter } from "react-router";
import { connect } from "react-redux";

// Static page

class DeliverySuccessComponent extends Component {
  render() {
    return (
      <div className="success-container" onClick={() => this.props.history.push('/orders')}>
        <div className="green-text fs-24 z-highest"><b>Successfully Delivered</b></div>
        <SuccessComponent/>
        <div className="green-text fs-22 z-highest">Tap to continue</div>
      </div>
    )
  }
}

export default withRouter(connect()(DeliverySuccessComponent));
